import script from "./gallery.vue?vue&type=script&lang=ts&setup=true"
export * from "./gallery.vue?vue&type=script&lang=ts&setup=true"

import "./gallery.vue?vue&type=style&index=0&id=130054f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130054f2"]])

export default __exports__